import BaseApi from "./BaseApi";

export default class Role extends BaseApi{
    construct() {}

    static async search(params) {
        return await Role.getAxiosInstance().get(Role.getApiUrl(),{params: params});
    }

    static async create(params) {
        return await Role.getAxiosInstance().post(Role.getApiUrl(),params);
    }

    static async update(params, id) {
        return await Role.getAxiosInstance().put(Role.getApiUrl() + id,params);
    }

    static async delete(id) {
        return await Role.getAxiosInstance().delete(Role.getApiUrl() + id);
    }

    static async find(id) {
        return await Role.getAxiosInstance().get(Role.getApiUrl() + id);
    }

    static async list(params) {
        let url = Role.getApiUrl() + "list";

        return Role.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/roles/";
    }
}